import React, { Component, Fragment } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';

export const archiveTransferScheduleMutation = gql`
  mutation archiveTransferSchedule($id: Int!) {
    archiveTransferSchedule(id: $id) {
      id
    }
  }
`;

export class TransferScheduleArchive extends Component {
  state = {
    isOpen: false,
    submitting: false,
    error: null
  };

  setError = error => {
    this.setState({ error });
  };

  setSubmitting = submitting => {
    this.setState({ submitting });
  };

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    const { className, transferSchedule, client, history } = this.props;

    if (!transferSchedule) {
      // In some cases where transferSchedule comes though asyncronously, there is a chance that the transferSchedule
      // does not exist yet. If that is the case, don't render anything
      return null;
    }

    const { submitting, error } = this.state;
    const { name } = transferSchedule;

    return (
      <Fragment>
        <Button className={className} color="danger" outline onClick={this.onToggle}>
          Archive
        </Button>
        <Modal isOpen={this.state.isOpen} toggle={this.onToggle}>
          <Mutation mutation={archiveTransferScheduleMutation}>
            {archiveTransferSchedule => (
              <Fragment>
                <ModalHeader toggle={this.onToggle}>Are you sure?</ModalHeader>
                <ModalBody>
                  {error && <Alert color="danger">{error}</Alert>}
                  Are you sure you want to archive the transfer schedule <em>{name}</em>?
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={this.onToggle}>
                    Cancel
                  </Button>{' '}
                  <Button
                    didabled={submitting}
                    color="primary"
                    onClick={async () => {
                      try {
                        this.setSubmitting(true);
                        await archiveTransferSchedule({
                          variables: {
                            id: transferSchedule.id
                          }
                        });
                        // Clear cache
                        client.resetStore();
                        history.push(`/settings/transfers?archived=${name}`);
                      } catch (err) {
                        this.setSubmitting(false);
                        this.setError('An unknown error occured');
                      }
                    }}
                  >
                    Archive
                  </Button>
                </ModalFooter>
              </Fragment>
            )}
          </Mutation>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(withApollo(TransferScheduleArchive));



// WEBPACK FOOTER //
// ./src/containers/transferScheduleArchive/transferScheduleArchive.jsx